import { ConnectorType } from "@pufflig/prompt-studio-types";
import { ConnectorFormConfig, Limitation } from "../../types";

const forms: ConnectorFormConfig = {
  postgres: [
    { id: "name", label: "Name", placeholder: "Name", isRequired: true },
    { id: "description", label: "Description", type: "textarea", placeholder: "Description", isRequired: false },
    { id: "host", label: "Host", limitation: Limitation.URL, placeholder: "127.0.0.1", isRequired: true },
    { id: "port", label: "Port", type: "number", limitation: Limitation.PORT, placeholder: "5432", isRequired: true },
    { id: "database", label: "Database", placeholder: "postgres", isRequired: true },
    { id: "username", label: "Username", placeholder: "postgres", isRequired: true },
    { id: "password", label: "Password", type: "password", placeholder: "postgres", isRequired: true },
  ],
  snowflake: [
    { id: "name", label: "Name", placeholder: "Name", isRequired: true },
    { id: "description", label: "Description", type: "textarea", placeholder: "Description", isRequired: false },
    { id: "account", label: "Account", placeholder: "snowflake", isRequired: true },
    { id: "warehouse", label: "Warehouse", placeholder: "snowflake", isRequired: true },
    { id: "database", label: "Database", placeholder: "snowflake", isRequired: true },
    { id: "username", label: "Username", placeholder: "snowflake", isRequired: true },
    { id: "privateKey", label: "Private Key", type: "password", placeholder: "snowflake", isRequired: true },
    { id: "passphrase", label: "Passphrase", type: "password", placeholder: "snowflake", isRequired: true },
  ],
  ms_fabric_sql: [
    { id: "name", label: "Name", placeholder: "My Fabric Connection", isRequired: true },
    { id: "description", label: "Description", type: "textarea", placeholder: "Description", isRequired: false },
    {
      id: "server_url",
      label: "Server URL",
      placeholder: "<YOUR_SERVER>.datawarehouse.fabric.microsoft.com",
      isRequired: true,
    },
    { id: "db_name", label: "Database Name", placeholder: "Lakehouse", isRequired: true },
    { id: "client_id", label: "Client ID", placeholder: "00000000-0000-0000-0000-000000000000", isRequired: true },
    { id: "client_secret", label: "Client Secret", type: "password", placeholder: "", isRequired: true },
    { id: "tenant_id", label: "Tenant ID", placeholder: "00000000-0000-0000-0000-000000000000", isRequired: true },
  ],
  bigquery: [
    { id: "name", label: "Name", placeholder: "Name", isRequired: true },
    { id: "description", label: "Description", type: "textarea", placeholder: "Description", isRequired: false },
    { id: "projectId", label: "Project ID", placeholder: "my-project", isRequired: true },
    { id: "location", label: "Location", placeholder: "US", isRequired: true },
    {
      id: "serviceAccountConfig",
      label: "Service Account Key JSON",
      type: "textarea",
      placeholder: '{ "client_email": "...", ... }',
      isRequired: true,
    },
  ],
};

export const getFields = (type: ConnectorType | null) => {
  return type ? forms[type as keyof typeof forms] : [];
};
